import { factoryYup } from 'app/core/factory-yup';

const yup = factoryYup();

const validations = yup.object().shape({
  comments: yup.string().max(1024)
});

export default validations;
